









import {Vue, Component, Prop} from 'vue-property-decorator';
import BubbleConfig from "@/types/BubbleConfig";

@Component
export default class BubbleAction extends Vue {

  @Prop({
    type: Object,
    default: {
      image: require('@/assets/plus.svg'),
      enabled: true,
    }
  })
  // @ts-ignore
  public config: BubbleConfig;
}

